import TextLine from './TextLine'

export default TextLine
